export function deleteDocument (state, { competitionId, documentId }) {
	const competitionIndex = state.competitions.findIndex(competition => competition.id === competitionId);

	if (competitionIndex < 0) return;

	const documents = state.competitions[competitionIndex].documents;

	const documentIndex = documents.findIndex(document => document.id === documentId);

	if (documentIndex < 0) return;

	documents.splice(documentIndex, 1);
}
